var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteFid = function SvgWhiteFid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.853 6A2.353 2.353 0 0 0 2.5 8.353v15.294C2.5 24.947 3.553 26 4.853 26h23.53c1.299 0 2.352-1.053 2.352-2.353V8.353c0-1.3-1.053-2.353-2.353-2.353z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    fillRule: "evenodd",
    d: "M4.853 7C4.106 7 3.5 7.606 3.5 8.353v15.294c0 .747.606 1.353 1.353 1.353h23.53c.747 0 1.352-.606 1.352-1.353V8.353c0-.747-.605-1.353-1.353-1.353zM2.5 8.353C2.5 7.053 3.553 6 4.853 6h23.53c1.299 0 2.352 1.053 2.352 2.353v15.294c0 1.3-1.053 2.353-2.353 2.353H4.852A2.353 2.353 0 0 1 2.5 23.647z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.921 16.007c1.008 3.812-.014 5.299-.421 5.993 1.053-1.1 2.638-3.57 1.953-6.166-.898-3.4-.445-4.858.229-5.834-2.369 2.553-2.112 4.68-1.76 6.007",
    clipRule: "evenodd"
  })));
};
export default SvgWhiteFid;